export function cookieValue(name: string): string | null {
  const prefix = `${encodeURIComponent(name)}=`;
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) return decodeURIComponent(trimmed.slice(prefix.length));
  }
  return null;
}

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers ?? {});
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const csrf = cookieValue('cta_csrf');
    if (csrf) headers.set('X-CSRF-Token', csrf);
  }
  const response = await fetch(input, { ...init, headers, credentials: 'same-origin' });
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
  if (response.status === 401 && !url.includes('/api/v1/auth/')) {
    window.dispatchEvent(new CustomEvent('cta-auth-required'));
  }
  return response;
}

export async function apiJson<T>(input: RequestInfo | URL, init: RequestInit = {}): Promise<T> {
  const response = await apiFetch(input, init);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const base = payload.detail ?? `${response.status} ${response.statusText}`;
    const requestId = typeof payload.request_id === 'string' && payload.request_id ? ` Request ID: ${payload.request_id}.` : '';
    throw new Error(`${base}${requestId}`);
  }
  return payload as T;
}
